import type { SelectionExtensionPluginOptions } from '@atlaskit/editor-plugin-selection-extension';

interface Props {
	options: never;
}

export function selectionExtensionPluginOptions({}: Props): SelectionExtensionPluginOptions {
	return {
		extensions: {},
	};
}
